



















import TitleBar from '@/modules/core/components/TitleBar.vue';
import CardComponent from '@/modules/core/components/CardComponent.vue';
import TagsTable from '../components/TagsTable.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    TitleBar,
    CardComponent,
    TagsTable,
  },
})
export default class TagList extends Vue {
  public get titleStack(): string[] {
    return ['Admin', 'Tags'];
  }
}
